import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ExperiencesService } from '../../services/experiences.service';
import { ExperienceShort } from '../../services/interfaces/experiences';
import { TransparencyService } from '../../utils/transparency.service';
import { kebabCase, range } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { Place } from 'app/services/interfaces/place';
import { Region, WineRegion } from 'app/services/interfaces/region';
import { CountryService } from 'app/services/country.service';
import { BlogService } from 'app/services/blog.service';
import { WordPressPost } from 'app/services/interfaces/wordpress-post';
import { LanguageService, SupportedLanguage } from '../../services/language.service';
import type { LocaleSettings } from 'primeng/calendar';
import { Subject, Subscription } from 'rxjs';
import { takeUntil, skip } from 'rxjs/operators';

/** Immagine condivisa per le card “Aree geografiche” e “Territori vinicoli” in homepage (TODO: da API). */
const HOMEPAGE_TERRITORY_CARD_IMAGE =
  'https://cdn.pixabay.com/photo/2022/10/31/21/34/castle-7560776_1280.jpg';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
})
export class HomepageComponent implements OnInit, OnDestroy, DoCheck {
linkToRegion(_t140: any) {
}

  @Input() isTransparent: boolean = true;
  datesText: string | undefined = 'Data o periodo';
  numPersone: string | undefined = 'Persone';
  @Output() dataEvent = new EventEmitter<{
    datesText: string | undefined;
    numPersone: string | undefined;
  }>();
  uniqueRegions: string[] = [];
  /** Max ospiti nella ricerca hero (p-inputNumber) */
  numberOfExperiences: number = 20;
  /** Quante esperienze caricare per il carosello homepage (multipli di 8 consigliati) */
  readonly homepageExperiencesFetchSize = 24;
  /** Card per slide: 2 file × 4 colonne */
  readonly homepageExperiencesPageSize = 8;
  locationName: string = 'Chiuri';
  experienceCardName: string = 'Esempio di esperienza a Chiuri';
  regionName: string = 'Toscana';
  regionalText: string = 'Regional text';

  blogTitle: string = 'This is an example of a blog title';
  blogText: string =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas semper sagittis malesuada. Morbi egestas tempus augue ac fermentum. Ut in.';

  minDate = new Date();

  rangeDates: Date[] | undefined;
  searchText: string | undefined;
  personNumber: number | undefined;
  images: { itemImageSrc: string }[] = [];
  /** Slide corrente nel carousel hero (custom, non p-galleria) */
  heroActiveSlide = 0;
  /** Intervallo autoplay hero (ms) — più lento per leggere la foto */
  readonly heroSlideIntervalMs = 10000;
  private heroCarouselInterval?: ReturnType<typeof setInterval>;
  closeIcon = 'pi pi-times';
  openIcon = 'pi pi-angle-down';

  isPersonShow = false;
  iconPerson = this.openIcon;
  numPax: number | undefined;

  isCalendarShow = false;
  iconCalendar = this.openIcon;

  isSearchShow = false;

  /** Hero: overlay scuro + toolbar bianca solo dopo interazione con la barra ricerca */
  heroToolbarActive = false;

  experiencesStats = {
    experiencesNum: 2850,
    experiencesNumReal: 2856,
    regions: 18,
    wineries: 210,
    users: 1254,
  };

  experiences: ExperienceShort[] = [];

  /**
   * Mock homepage — "Esplora per Aree geografiche".
   * TODO: sostituire con JSON / API.
   */
  homepageGeographicRegionsMock: Region[] = [
    {
      id: 1,
      name: 'Toscana',
      discoverText: 'Centro Italia',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Toscana',
      },
      numExperiences: 325,
      link: '/toscana',
      short_description: 'Paesaggi tra Firenze, Siena e le colline del Chianti.',
    },
    {
      id: 2,
      name: 'Veneto',
      discoverText: 'Nord-Est',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Veneto',
      },
      numExperiences: 280,
      link: '/veneto',
      short_description: 'Prosecco, laghi e città d’arte tra Verona e Venezia.',
    },
    {
      id: 3,
      name: 'Piemonte',
      discoverText: 'Nord-Ovest',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Piemonte',
      },
      numExperiences: 198,
      link: '/piemonte',
      short_description: 'Langhe, Barolo e tartufi tra vigne patrimonio UNESCO.',
    },
    {
      id: 4,
      name: 'Sicilia',
      discoverText: 'Isole e Sud',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Sicilia',
      },
      numExperiences: 156,
      link: '/sicilia',
      short_description: 'Vini vulcanici, mare e cantine sull’Etna.',
    },
    {
      id: 5,
      name: 'Puglia',
      discoverText: 'Sud',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Puglia',
      },
      numExperiences: 142,
      link: '/puglia',
      short_description: 'Itria, ulivi secolari e ospitalità tra due mari.',
    },
    {
      id: 6,
      name: 'Lombardia',
      discoverText: 'Nord',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Lombardia',
      },
      numExperiences: 210,
      link: '/lombardia',
      short_description: 'Franciacorta, Lago d’Iseo e vigneti prealpini.',
    },
    {
      id: 7,
      name: 'Campania',
      discoverText: 'Sud',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Campania',
      },
      numExperiences: 95,
      link: '/campania',
      short_description: 'Costiera, Taurasi e tradizioni vitivinicole antiche.',
    },
    {
      id: 8,
      name: 'Sardegna',
      discoverText: 'Isole',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Sardegna',
      },
      numExperiences: 88,
      link: '/sardegna',
      short_description: 'Vermentino, Cannonau e cantine tra macchia e mare.',
    },
  ];

  /**
   * Mock homepage — "Esplora per Territori vinicoli".
   * TODO: sostituire con risposta API (es. countryService.getWineRegion()).
   */
  homepageWineRegionsMock: WineRegion[] = [
    {
      id: 1,
      name: 'Chianti Classico',
      discoverText: 'Toscana',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Chianti',
      },
      numExperiences: 125,
      short_description: 'Il cuore storico del Chianti tra Gaiole e Castellina.',
    },
    {
      id: 2,
      name: 'Barolo',
      discoverText: 'Piemonte',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Barolo',
      },
      numExperiences: 98,
      short_description: 'Re dei vini: Nebbiolo sulle colline delle Langhe.',
    },
    {
      id: 3,
      name: 'Franciacorta',
      discoverText: 'Lombardia',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Franciacorta',
      },
      numExperiences: 76,
      short_description: 'Metodo classico tra Brescia e il lago d’Iseo.',
    },
    {
      id: 4,
      name: 'Valpolicella',
      discoverText: 'Veneto',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Valpolicella',
      },
      numExperiences: 112,
      short_description: 'Amarone e Ripasso tra Verona e Lessinia.',
    },
    {
      id: 5,
      name: 'Brunello di Montalcino',
      discoverText: 'Toscana',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Montalcino',
      },
      numExperiences: 64,
      short_description: 'Sangiovese in purezza sulle pendici del Montalcino.',
    },
    {
      id: 6,
      name: 'Prosecco Valdobbiadene',
      discoverText: 'Veneto',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Prosecco',
      },
      numExperiences: 143,
      short_description: 'Colline UNESCO del Conegliano Valdobbiadene.',
    },
    {
      id: 7,
      name: 'Bolgheri',
      discoverText: 'Toscana',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Bolgheri',
      },
      numExperiences: 52,
      short_description: 'Super tuscan e cipressi sulla strada del vino.',
    },
    {
      id: 8,
      name: 'Etna DOC',
      discoverText: 'Sicilia',
      headerImg: {
        src: HOMEPAGE_TERRITORY_CARD_IMAGE,
        alt: 'Etna',
      },
      numExperiences: 41,
      short_description: 'Nerello Mascalese sui pendii vulcanici.',
    },
  ];

  /**
   * Stessi dati del mock: disponibili da subito (no attesa AfterViewInit) per hero + carosello.
   * Con API: aggiornare in loadWineRegion().
   */
  wineRegions: WineRegion[] = [...this.homepageWineRegionsMock];

  /** Card per “fila” nei caroselli territori / aree (una slide = una riga) */
  readonly homepageTerritoryRowPageSize = 4;

  responsiveOptionsExperience = [
    {
      breakpoint: '1470px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: '1000px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: '800px',
      numVisible: 2,
      numScroll: 2,
    },
  ];

  territoriVinicoli = [
    {
      label: 'Langhe',
    },
    {
      label: 'Chianti Classico',
    },
    {
      label: 'Valpolicella',
    },
    {
      label: 'Barolo',
    },
    {
      label: 'Franciacorta',
    },
    {
      label: 'Valdobbiadene',
    },
    {
      label: 'Oltrepò Pavese',
    },
    {
      label: 'Bolgheri',
    },
    {
      label: 'Montalcino',
    },
  ];

  posts: WordPressPost[] = [];
  loadingPosts = true;
  error = '';
  private destroy$ = new Subject<void>();
  private blogSubscription?: Subscription;
  private documentPointerDownUnlisten?: () => void;

  /** Locale calendario hero (giorni / mesi) per lingua UI */
  private readonly heroCalendarLocales: Record<SupportedLanguage, LocaleSettings> = {
    it: {
      firstDayOfWeek: 1,
      dayNamesMin: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      monthNames: [
        'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
        'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre',
      ],
      monthNamesShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
      today: 'Oggi',
      clear: 'Pulisci',
      dateFormat: 'dd/mm/yy',
    },
    en: {
      firstDayOfWeek: 1,
      dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      monthNames: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'dd/mm/yy',
    },
    de: {
      firstDayOfWeek: 1,
      dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
      monthNames: [
        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
        'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      today: 'Heute',
      clear: 'Löschen',
      dateFormat: 'dd/mm/yy',
    },
    fr: {
      firstDayOfWeek: 1,
      dayNamesMin: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      monthNames: [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
      ],
      monthNamesShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
      today: "Aujourd'hui",
      clear: 'Effacer',
      dateFormat: 'dd/mm/yy',
    },
  };

  constructor(
    private experienceServices: ExperiencesService,
    private transparencyService: TransparencyService,
    private countryService: CountryService,
    private router: Router,
    private route: ActivatedRoute,
    private blogService: BlogService,
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr: ChangeDetectorRef,
    private el: ElementRef<HTMLElement>,
    private ngZone: NgZone,
    private renderer: Renderer2
  ) {
    this.transparencyService.setTransparency(true);
  }

  get heroCalendarLocale(): LocaleSettings {
    return this.heroCalendarLocales[this.languageService.getCurrentLanguage()];
  }

  /** Riepilogo testuale periodo (come mockup) */
  get heroCalendarRangeSummary(): string {
    const rd = this.rangeDates;
    if (!rd?.length || !rd[0]) {
      return '';
    }
    const loc = this.getCalendarDateLocaleTag();
    if (rd.length >= 2 && rd[1]) {
      const y0 = rd[0].getFullYear();
      const y1 = rd[1].getFullYear();
      const sameYear = y0 === y1;
      const o0: Intl.DateTimeFormatOptions = sameYear
        ? { day: 'numeric', month: 'long' }
        : { day: 'numeric', month: 'long', year: 'numeric' };
      const o1: Intl.DateTimeFormatOptions = sameYear
        ? { day: 'numeric', month: 'long' }
        : { day: 'numeric', month: 'long', year: 'numeric' };
      return `${rd[0].toLocaleDateString(loc, o0)} – ${rd[1].toLocaleDateString(loc, o1)}`;
    }
    return rd[0].toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' });
  }

  private getCalendarDateLocaleTag(): string {
    const m: Record<SupportedLanguage, string> = {
      it: 'it-IT',
      en: 'en-GB',
      de: 'de-DE',
      fr: 'fr-FR',
    };
    return m[this.languageService.getCurrentLanguage()] || 'it-IT';
  }

  clearHeroDateRange(): void {
    this.fieldReset(1);
  }

  /** True se il click/focus è sulla toolbar hero o sui suoi overlay (calendar, località, persone). */
  private isWithinHeroSearchChrome(node: EventTarget | null): boolean {
    if (!node || !(node instanceof Node)) {
      return false;
    }
    const root: Element | null =
      node instanceof Element ? node : (node.parentElement ?? null);
    if (!root) {
      return false;
    }
    const toolbar = this.el.nativeElement.querySelector('.searchbarHomepage');
    if (toolbar?.contains(root)) {
      return true;
    }
    if (root.closest('[data-hero-search-overlay]')) {
      return true;
    }
    /* Contenuto panel località (clic sulle suggestion) */
    if (root.closest('.hero-location-suggestions')) {
      return true;
    }
    const op = root.closest('.p-overlaypanel');
    if (!op) {
      return false;
    }
    return (
      op.classList.contains('hero-location-panel') ||
      op.classList.contains('hero-calendar-panel') ||
      op.classList.contains('hero-person-panel')
    );
  }

  onHeroSearchbarFocusOut(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    setTimeout(() => {
      const ae = document.activeElement;
      this.heroToolbarActive = this.isWithinHeroSearchChrome(ae);
      this.cdr.markForCheck();
    }, 0);
  }

  ngOnInit(): void {
    this.loadImage();
    this.numPersone = this.numPax
      ? this.numPax?.toString() + ' persone'
      : 'Persone';
    this.datesText = this.rangeDates
      ? this.rangeDates?.toString()
      : 'Data o periodo';

    // Carica blog solo nel browser (evita errore DNS durante SSR in locale)
    if (isPlatformBrowser(this.platformId)) {
      this.loadPosts();
      /* pointerdown fuori da NgZone: altrimenti ogni click (anche sulle frecce SVG del calendario)
         forza un CD globale → writeValue sul p-calendar → updateUI() ripristina il mese corrente. */
      this.ngZone.runOutsideAngular(() => {
        this.documentPointerDownUnlisten = this.renderer.listen('document', 'pointerdown', (event: Event) => {
          const next = this.isWithinHeroSearchChrome(event.target);
          if (next === this.heroToolbarActive) {
            return;
          }
          this.ngZone.run(() => {
            this.heroToolbarActive = next;
            this.cdr.markForCheck();
          });
        });
      });
    }

    // Al cambio lingua: ricarica esperienze e blog (skip(1) evita doppia chiamata al primo caricamento)
    this.languageService.currentLanguage$
      .pipe(skip(1), takeUntil(this.destroy$))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.getMainPageExperiences();
          this.loadPosts();
        }
      });
  }

  ngOnDestroy(): void {
    this.documentPointerDownUnlisten?.();
    this.stopHeroCarousel();
    this.blogSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  startHeroCarousel(): void {
    this.stopHeroCarousel();
    if (!isPlatformBrowser(this.platformId) || !this.images?.length || this.images.length < 2) {
      return;
    }
    this.heroCarouselInterval = setInterval(() => {
      this.heroActiveSlide = (this.heroActiveSlide + 1) % this.images.length;
      this.cdr.markForCheck();
    }, this.heroSlideIntervalMs);
  }

  stopHeroCarousel(): void {
    if (this.heroCarouselInterval != null) {
      clearInterval(this.heroCarouselInterval);
      this.heroCarouselInterval = undefined;
    }
  }

  goToHeroSlide(index: number): void {
    if (!this.images?.length || index < 0 || index >= this.images.length) {
      return;
    }
    this.heroActiveSlide = index;
    this.startHeroCarousel();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.getMainPageExperiences();
        this.fetchUniqueRegions();
        this.loadWineRegion();
      }, 0);
    }
  }

  loadPosts(): void {
    this.blogSubscription?.unsubscribe();
    this.loadingPosts = true;
    this.blogSubscription = this.blogService.getPosts().subscribe({
      next: (posts) => {
        this.posts = posts || [];
        this.loadingPosts = false;
        this.error = '';
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.error = 'Si è verificato un errore nel caricamento dei post';
        this.loadingPosts = false;
        this.posts = [];
      }
    });
  }

  getTags(post: WordPressPost): string[] {
    return post.tags?.map(t => t.name) || [];
  }

  getFeaturedImage(post: WordPressPost): string {
    return post.thumbnail || 'assets/placeholder.jpg';
  }

  getExcerpt(post: WordPressPost, maxLen = 120): string {
    if (post.excerpt?.trim()) {
      return post.excerpt.length > maxLen ? post.excerpt.slice(0, maxLen) + '...' : post.excerpt;
    }
    const stripped = (post.content || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    return stripped.length > maxLen ? stripped.slice(0, maxLen) + '...' : stripped;
  }


  ngDoCheck(): void {
    if (this.rangeDates != undefined) {
      const formatted = this.formatDateRange(this.rangeDates);
      if (formatted) {
        this.datesText = formatted;
        this.iconCalendar = this.closeIcon;
      }
    } else {
      this.datesText = 'Data o periodo';
      this.iconCalendar = this.openIcon;
    }
    if (this.numPax != undefined) {
      this.numPersone =
        this.numPax > 1
          ? this.numPax.toString() + ' persone'
          : this.numPax.toString() + ' persona';
      this.iconPerson = this.closeIcon;
    } else {
      this.numPersone = 'Persone';
      this.iconPerson = this.openIcon;
    }
  }
  fetchUniqueRegions(): void {
    // Esegui solo nel browser, non durante SSR
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    
    this.experienceServices.list({} as any).subscribe({
      next: (response) => {
        const experiences = response?.content;
        if (experiences) {
          this.uniqueRegions = this.experienceServices.getAllRegionsFromExperiences(experiences);
        } else {
          this.uniqueRegions = [];
        }
      },
      error: (err) => {
        this.uniqueRegions = [];
      }
    });
  }

  loadWineRegion(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    // Mock homepage — sostituire con API quando pronta:
    // this.countryService.getWineRegion().subscribe((r) => { this.wineRegions = r?.length ? r : this.homepageWineRegionsMock; });
    this.wineRegions = [...this.homepageWineRegionsMock];
    this.cdr.markForCheck();
  }

  async getMainPageExperiences() {
    // Esegui solo nel browser, non durante SSR
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.experienceServices
      .listCard({ page: 0, size: this.homepageExperiencesFetchSize, lang: this.languageService.getCurrentLanguage() })
      .subscribe(
        (experiencesPage) => {
          // Usa `data` come in experiences.component.ts e pulisci le esperienze
          if (experiencesPage && experiencesPage.data) {
            this.experiences = this.experienceServices.cleanExperiencesCard(experiencesPage.data);
          } else if (experiencesPage && experiencesPage.content) {
            // Fallback a content se data non esiste
            this.experiences = this.experienceServices.cleanExperiencesCard(experiencesPage.content);
          } else {
            this.experiences = [];
          }
        },
        (error) => {
          console.error("Errore durante la chiamata API:", error);
          this.experiences = [];
        }
      );
  }


  loadImage(): void {
    const files = [
      'degustazione-vini-in-cantina.jpg',
      'smart tasting degustazione vini.jpg',
      'umo che degusta vino in cantina.jpg',
    ];
    this.images = files.map((name) => ({
      itemImageSrc: `assets/images/${encodeURI(name)}`,
    }));
    this.heroActiveSlide = 0;
    this.startHeroCarousel();
  }

  /** Suggerimenti località per il dropdown hero (filtrati da searchText) */
  getHeroLocationSuggestions(): { label: string; sub?: string }[] {
    const q = (this.searchText || '').trim().toLowerCase();
    const fromWine: { label: string; sub?: string }[] = (this.wineRegions || []).map((w) => ({
      label: `${w.name} (Regione vitivinicola)`,
      sub:
        w.numExperiences != null
          ? `${w.numExperiences} esperienze`
          : undefined,
    }));
    const fromRegions: { label: string; sub?: string }[] = (this.uniqueRegions || []).map((name) => ({
      label: `${name} (Regione)`,
      sub: undefined,
    }));
    const merged = [...fromWine, ...fromRegions].filter(
      (item, i, arr) => arr.findIndex((x) => x.label === item.label) === i
    );
    const filtered = q
      ? merged.filter((m) => m.label.toLowerCase().includes(q))
      : merged;
    return filtered.slice(0, 8);
  }

  clearLocationSearch(): void {
    this.searchText = '';
  }

  selectHeroLocation(s: { label: string }): void {
    const base = s.label.replace(/\s*\([^)]*\)\s*$/, '').trim();
    this.searchText = base;
  }

  /** Pagine da 8 card per p-carousel (ogni item = una slide con griglia 4×2) */
  get experienceHomepagePages(): ExperienceShort[][] {
    const list = this.experiences || [];
    const size = this.homepageExperiencesPageSize;
    const pages: ExperienceShort[][] = [];
    for (let i = 0; i < list.length; i += size) {
      pages.push(list.slice(i, i + size));
    }
    return pages;
  }

  /**
   * Territori vinicoli / aree geografiche: una slide = una sola fila (4 card),
   * così PrimeNG non dispone 8 item su 2 righe.
   */
  get wineRegionsHomepagePages(): WineRegion[][] {
    return this.chunkHomepageRows(this.wineRegions, this.homepageTerritoryRowPageSize);
  }

  get geographicRegionsHomepagePages(): Region[][] {
    return this.chunkHomepageRows(this.homepageGeographicRegionsMock, this.homepageTerritoryRowPageSize);
  }

  private chunkHomepageRows<T>(items: T[] | undefined, pageSize: number): T[][] {
    const list = items || [];
    const pages: T[][] = [];
    for (let i = 0; i < list.length; i += pageSize) {
      pages.push(list.slice(i, i + pageSize));
    }
    return pages;
  }

  trackByWineRegionId(_index: number, r: WineRegion): number {
    return r.id;
  }

  trackByGeographicRegionId(_index: number, r: Region): number {
    return r.id;
  }

  get experiencesListUrl(): string {
    const prefix = this.languageService.getLanguagePrefix();
    return prefix ? `${prefix}/experiences` : '/experiences';
  }

  trackByExperienceId(_index: number, exp: ExperienceShort): string {
    return exp?.id ?? String(_index);
  }

  linkToExperience(experienceId: string, experienceName: string): void {
    const kebabName = kebabCase(experienceName);
    const langPrefix = this.languageService.getLanguagePrefix();
    const url = langPrefix ? `${langPrefix}/experience/${kebabName}__${experienceId}` : `/experience/${kebabName}__${experienceId}`;
    this.router.navigateByUrl(url);
  }

  linkToExperiences(): void {
    const kebabName = kebabCase();
    const langPrefix = this.languageService.getLanguagePrefix();
    const url = langPrefix ? `${langPrefix}/experiences` : `/experiences`;
    this.router.navigateByUrl(url);
    //TODO 
    this.dataEvent.emit({
      datesText: this.datesText,
      numPersone: this.numPersone,
    });
  }

  linkToTerritories(label:string):void{
    const langPrefix = this.languageService.getLanguagePrefix();
    const url = langPrefix ? `${langPrefix}/territories/${label}` : `/territories/${label}`;
    this.router.navigateByUrl(url);
  }

  fieldReset(arg: any): void {
    switch (arg) {
      case 0: {
        this.clearLocationSearch();
        break;
      }
      case 1: {
        //calendar
        if (this.iconCalendar == this.closeIcon && this.rangeDates) {
          this.rangeDates = undefined;
          this.datesText = 'Data o periodo';
          this.iconCalendar = this.openIcon;
        }
        break;
      }
      case 2: {
        //person
        if (this.iconPerson == this.closeIcon && this.numPax) {
          this.numPax = undefined;
          this.numPersone = 'Persone';
          this.iconPerson = this.openIcon;
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  formatDateRange(dates: any) {
    if (!dates || dates.length < 2) {
      return '';
    }

    const [startDate, endDate] = dates;

    const loc = this.getCalendarDateLocaleTag();
    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' };

    // Format the start and end dates
    const start = startDate.toLocaleDateString(loc, options).split(' ');
    const end = endDate.toLocaleDateString(loc, options).split(' ');

    let formattedDateRange;

    if (start[1] === end[1] && start[2] === end[2]) {
      // Same month and year
      formattedDateRange = `${start[0]}-${end[0]} ${start[1]} ${start[2]}`;
    } else {
      // Different month or year
      formattedDateRange = `${start[0]} ${start[1]} ${start[2]} - ${end[0]} ${end[1]} ${end[2]}`;
    }

    return formattedDateRange;
  }
}
